import { SearchX } from "lucide-react";
import { SkeletonGrid } from "./SkeletonCard";
import type { ViewMode } from "./ViewToggle";

type LoadingProps = {
  view?: ViewMode;
  count?: number;
};

export function LoadingState({ view = "grid", count = 8 }: LoadingProps) {
  return <SkeletonGrid view={view} count={count} />;
}

type EmptyProps = {
  hasFilters?: boolean;
  onClearFilters?: () => void;
};

export function EmptyState({ hasFilters = false, onClearFilters }: EmptyProps) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon" aria-hidden>
        <SearchX size={28} />
      </div>
      <h2 className="empty-state-title">No matches found</h2>
      <p className="empty-state-text">
        {hasFilters
          ? "Try clearing a filter or adjusting your search to see more items."
          : "There aren't any items here yet. Check back soon."}
      </p>
      {hasFilters && onClearFilters ? (
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onClearFilters}
        >
          Clear filters
        </button>
      ) : null}
    </div>
  );
}
